export default "__VITE_ASSET__BTuHhW3y__"